import brandLogoTm from "src/app/assets/brand-logo-tm.svg";
import brandLogoTabla from "src/app/assets/brand-logo-tabla.svg";
import brandLogoSm from "src/app/assets/brand-logo-sm.svg";
import brandLogoZb from "src/app/assets/brand-logo-zb.svg";

export const brandLogo: Record<string, string> = {
  zb: brandLogoZb,
  tm: brandLogoTm,
  sm: brandLogoSm,
  tabla: brandLogoTabla,
};

export const MIN_DESKTOP_WIDTH = 440;

export const SUBSCRIBE_URL: string = "https://subscribe.sph.com.sg";

// NLB external login constants
export const SESSION_KEY_AUTH_ORIGIN = "auth_origin";
export const NLB_AUTH_ORIGIN = "nlb";
export const NLB_STG_AUTH_ORIGIN = "nlbstg";
export const NLB_SESSION_EXPIRED_URL = "/nlb/session-expired";
